import { render, staticRenderFns } from "./ExtrenalForm.vue?vue&type=template&id=6c7205d2&scoped=true&"
import script from "./ExtrenalForm.vue?vue&type=script&lang=js&"
export * from "./ExtrenalForm.vue?vue&type=script&lang=js&"
import style0 from "./ExtrenalForm.vue?vue&type=style&index=0&id=6c7205d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7205d2",
  null
  
)

export default component.exports